class BESSAppProjectDetailsEditorSiteTypeManager extends BESSAppProjectEditorManagerBase {

    constructor(editor, parent) {
        super(editor);
        this.parent = parent;
        this.siteTypeInput = this.editor.projectInputs.siteType;
        this.siteTypeInputConfirming = false;
        this.siteType = this.siteTypeInput.value.value;
        this.siteTypeInput.addChangeRule(this.#onSiteTypeChanged.bind(this))
    }


    #onSiteTypeChanged(value) {
        if (value != null) {
            if (this.siteTypeInputConfirming) {
                return;
            }
            this.siteTypeInputConfirming = true;
            this.askUserToConfirm(
                "Site type",
                "Warning. Changing this attribute of your project may cause some or all of your existing project profile data to be reset if you update. Do you want to proceed?",
                this.#onConfirmChangeSiteType.bind(this),
                "Yes - change site type",
                "No - undo this change",
                this.#onDismissChangeSiteType.bind(this)
            );
            return false;
        }
        this.siteType = this.siteTypeInput.value.value;
        return true;
    }

    #onConfirmChangeSiteType() {
        this.parent.siteTypeChanged = true;
        this.siteTypeInputConfirming = false;
        this.siteTypeInput.fireChangedEvents();
    }

    #onDismissChangeSiteType() {
        this.siteTypeInput.setValue({key: this.siteType});
        this.siteTypeInputConfirming = false;
    }
}